:host {
  display: contents;
  --ip-icon-color: var(--ip-colors-dark-base);
}
:host button {
  cursor: pointer;
  background: transparent;
  border: none;
  color: var(--ip-icon-color);
  padding: 0;
}